import useMount from '@src/utils/hooks/use-mount';
import { observable, computed } from 'mobx';
import BaseSwiperStore from '@src/components/swiper/base-swiper/store';
import BaseStore from '@src/utils/store/base-store';
import { useEffect } from 'react';
class WelfareSectionStore extends BaseStore {
  constructor(options = {}) {
    super();
    Object.assign(this, options);
  }

  @observable isActive = false;

  //左侧tab列表
  tabList = [{ name: '福利' }, { name: '时装' }, { name: '活动' }];

  //福利轮播列表
  welfareList = [{ img: require('./images/welfare-img1.jpg') }, { img: require('./images/welfare-img2.jpg') }, { img: require('./images/welfare-img3.jpg') }];

  //新时装列表
  fashionImgList = [
    { img: require('./images/fashion-img1.png') },
    { img: require('./images/fashion-img2.png') },
    { img: require('./images/fashion-img3.png') },
    { img: require('./images/fashion-img4.png') },
    { img: require('./images/fashion-img5.png') },
    { img: require('./images/fashion-img6.png') }
  ];

  //复刻时装轮播列表
  reproductionList = [
    { img: require('./images/reproduction-img1.jpg') },
    { img: require('./images/reproduction-img2.jpg') },
    { img: require('./images/reproduction-img3.jpg') }
  ];

  //当前tab索引
  @observable tabIndex = 0;

  //活动列表
  activityImgList = [
    { img: require('./images/activityImg1.png') },
    { img: require('./images/activityImg2.png') },
    { img: require('./images/activityImg3.png') },
    { img: require('./images/activityImg4.png') }
  ];

  //当前时装索引
  @observable fashionImgIndex = 0;

  /**
   * 福利轮播图
   * @type {BaseSwiperStore}
   */
  welfareSwiper = new BaseSwiperStore({
    swiperOptions: {
      observe: true,
      observeParents: true,
      loop: false,
      autoplay: false,
      effect: 'creative',
      loop: true
    }
  });
  /**
   * 新时装轮播列表
   * @type {BaseSwiperStore}
   */
  fashionSwiper = new BaseSwiperStore({
    swiperOptions: {
      observe: true,
      observeParents: true,
      slidesPerView: 1,
      autoplay: false,
      effect: 'slide',
      loop: true,
      centeredSlides: true
    }
  });

  /**
   * 复刻时装轮播列表
   * @type {BaseSwiperStore}
   */
  reproductionSwiper = new BaseSwiperStore({
    // swiperOptions: {
    //   observe: true,
    //   observeParents: true,
    //   slidesPerView: 1,
    //   autoplay: false,
    //   effect: 'slide',
    //   loop: true,
    //   centeredSlides: true
    // }
    swiperOptions: {
      observe: true,
      observeParents: true,
      loop: false,
      autoplay: false,
      effect: 'creative',
      loop: true
    }
  });

  // /**
  //  * 活动列表轮播
  //  * @type {BaseSwiperStore}
  //  */
  // activitySwiperStore = new BaseSwiperStore({
  //   swiperOptions: {
  //     observe: true,
  //     observeParents: true,
  //     loop: false,
  //     spaceBetween: 10,
  //     slidesPerView: 4,
  //     autoplay: false,
  //     effect: 'creative',
  //     loop: true,
  //     allowTouchMove: false
  //   }
  // });

  /**
   * 切换tab
   * @param {number} index - tab索引
   */
  clickTab(index) {
    this.tabIndex = index;
  }

  /**
   * 时装轮播图goPrev
   */
  clickFashionPrev() {
    if (this.tabIndex === 0) {
      this.welfareSwiper.goPrev();
      return;
    }

    if (this.fashionImgIndex === 0) {
      this.fashionSwiper.goPrev();
    } else {
      this.reproductionSwiper.goPrev();
    }
  }

  /**
   * 新时装轮播图goNext
   */
  clickFashionNext() {
    if (this.tabIndex === 0) {
      this.welfareSwiper.goNext();
      return;
    }
    if (this.fashionImgIndex === 0) {
      this.fashionSwiper.goNext();
    } else {
      this.reproductionSwiper.goNext();
    }
  }

  /**
   * 切换时装tab
   * @param {number} index - 时装tab索引
   */
  clickFashionTab(index) {
    this.fashionImgIndex = index;
  }

  use() {
    useMount(() => {});
    useEffect(
      () => {
        this.isActive = this.mainStore.pageSwiperIndex === 1;
      },
      [this.mainStore.pageSwiperIndex]
    );
  }
}

export default WelfareSectionStore;
